<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.33329 12.332H10.6666C10.8434 12.332 11.013 12.4023 11.138 12.5273C11.2631 12.6523 11.3333 12.8219 11.3333 12.9987C11.3333 13.1755 11.2631 13.3451 11.138 13.4701C11.013 13.5951 10.8434 13.6654 10.6666 13.6654H1.33329C1.15648 13.6654 0.986912 13.5951 0.861888 13.4701C0.736864 13.3451 0.666626 13.1755 0.666626 12.9987C0.666626 12.8219 0.736864 12.6523 0.861888 12.5273C0.986912 12.4023 1.15648 12.332 1.33329 12.332ZM0.666626 8.9987L7.33329 2.33203L9.33329 4.33203L2.66663 10.9987H0.666626V8.9987ZM7.99996 1.66536L9.33329 0.332031L11.3333 2.33203L9.99929 3.66603L7.99996 1.66536Z"
      fill="#404A57"
    />
  </svg>
</template>

<script>
export default {
    name:'IconEdit'
};
</script>

<style></style>
